import { useContext } from 'react';
import { FlowBuilder2PageContext } from './FlowBuilder2PageContext';

export const useFlowBuilder2PageContext = () => {
  const context = useContext(FlowBuilder2PageContext);
  if (!context)
    throw new Error(
      'useFlowBuilder2PageContext must be used under FlowBuilder2PageContextProvider',
    );
  return context;
};
